import { useEffect, useState } from 'react';
import { Card, Form, Button, Alert, Spinner, Table, Row, Col } from 'react-bootstrap';
import { api } from '../api/client';

export default function AdminSubjects() {
  const [subjects, setSubjects] = useState([]);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = async () => {
    setLoading(true);
    try {
      setSubjects(await api.get('/admin/subjects'));
    } catch (e) {
      setMsg({ type: 'danger', text: e.message });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post('/admin/subjects', { name: name.trim() });
      setName('');
      setMsg({ type: 'success', text: 'Subject added.' });
      await load();
    } catch (e2) {
      setMsg({ type: 'danger', text: e2.message });
    }
  };

  const remove = async (id, n) => {
    if (!window.confirm(`Delete "${n}"? This will unlink it from all teachers who teach it.`)) return;
    try {
      await api.del('/admin/subjects/' + id);
      await load();
    } catch (e) {
      setMsg({ type: 'danger', text: e.message });
    }
  };

  return (
    <>
      <h3 className="mb-4">Subjects</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}

      <Card className="shadow-sm mb-3" style={{ maxWidth: 600 }}>
        <Card.Body>
          <Card.Title>Add a subject</Card.Title>
          <Form onSubmit={add}>
            <Row>
              <Col><Form.Control value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g., French" /></Col>
              <Col xs="auto"><Button type="submit">Add</Button></Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {loading ? <div className="text-center py-4"><Spinner /></div> : (
        <Table bordered hover responsive className="bg-white" style={{ maxWidth: 600 }}>
          <thead className="table-dark"><tr><th style={{ width: 60 }}>#</th><th>Subject</th><th style={{ width: 120 }}></th></tr></thead>
          <tbody>
            {subjects.map((s, i) => (
              <tr key={s.id}>
                <td>{i + 1}</td>
                <td>{s.name}</td>
                <td><Button size="sm" variant="outline-danger" onClick={() => remove(s.id, s.name)}>Delete</Button></td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
